"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return createCursor;
    }
});
const _KonvaText = /*#__PURE__*/ _interop_require_default(require("../KonvaShapes/KonvaText.js"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function createCursor(props = {}) {
    const { text, position = {
        x: 0,
        y: 0
    }, strokeWidth } = props;
    const label = (0, _KonvaText.default)({
        text,
        position,
        offset: {
            x: -8,
            y: -8
        },
        listening: false,
        stroke: "black",
        strokeWidth
    });
    return label;
}
